import {WFSCrudService} from '../../core/services'

export class AppWfsCrudService extends WFSCrudService {}
